import { eBienLaiViewTheoLopActionsObj } from "../../action-types/bien-lai/IBienLaiViewTheoLopActionTypes";
import { generateActions } from "../generateActions";

export const bienLaiViewTheoLopActions = {
  ...generateActions(eBienLaiViewTheoLopActionsObj, "BIEN_LAI_VIEW_THEO_LOP"),
};
